import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import FeeSchedule from '@/views/fee/steps/Schedule.vue';

export function feeScheduleRoute(name: string, edit: boolean): RouteConfig {
  const path = `schedule${edit ? '' : '/:feeId'}`;

  return {
    name,
    path,
    component: FeeSchedule,
    meta: {},
    props: { edit },
    beforeEnter: (to: any, from: any, next: any) => {
      store.commit('fee/setId', tryParseInt(to.params.feeId));
      store
        .dispatch('fee/get')
        .then(() => next())
        .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać danych składki.' }));
    }
  };
}
